// extracted by mini-css-extract-plugin
export default {"blog_container":"AddBlog_blog_container__o5xoo","blog":"AddBlog_blog__zyD7v","input_":"AddBlog_input___36Pmh","text_editor":"AddBlog_text_editor__mnhDV","post":"AddBlog_post__2vm7L"};